import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { Designation } from '../models/designation.model';
import { environment } from '../../environments/environment';

export interface CreateDesignationDto {
  name: string;
  description?: string;
  isActive?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class DesignationService {
  private apiUrl = `${environment.apiUrl}/Designation`;

  constructor(private http: HttpClient) { }

  getAllDesignations(): Observable<Designation[]> {
    return this.http.get<Designation[]>(this.apiUrl).pipe(retry(2));
  }

  addDesignation(designation: Designation): Observable<Designation> {
    const createDto: CreateDesignationDto = {
      name: designation.name,
      description: designation.description,
      isActive: designation.isActive !== undefined ? designation.isActive : true
    };
    return this.http.post<Designation>(this.apiUrl, createDto);
  }

  updateDesignation(id: string, designation: Designation): Observable<Designation> {
    return this.http.put<Designation>(`${this.apiUrl}/${id}`, designation);
  }
}


